import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import GlobalStyles from './styles/GlobalStyles';

// Import pages
import Home from './pages/Home/Home';
import Contact from './pages/Contact/Contact';
import About from './pages/About/About';
import Fixtures from './pages/Fixtures/Fixtures';
import Results from './pages/Results/Results';
import PlayerStats from './pages/PlayerStats/PlayerStats';
import PlayerProfile from './pages/PlayerProfile/PlayerProfile';
import Shop from './pages/Shop/Shop';
import Error from './pages/Error/Error';
import Sponsors  from './pages/Sponosrs/Sponsors';
import Login from './pages/Login/Login';
import RequireAdmin from './components/RequireAdmin';

import Admin from './pages/Admin/Admin';
import AddFixture from './pages/Admin/AddFixture';
import GameSheet from './pages/Admin/GameSheet';
import AddPlayer from './pages/Admin/AddPlayer';
import AmendPlayer from './pages/Admin/AmendPlayer';
import DeletePlayer from './pages/Admin/DeletePlayer';
import AddTeamLogo from './pages/Admin/AddTeamLogo';

const App: React.FC = () => {
  return (
    <Router>
      <GlobalStyles />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/sponsors" element={<Layout><Sponsors /></Layout>} />
        <Route path="/fixtures" element={<Layout><Fixtures /></Layout>} />
        <Route path="/results" element={<Layout><Results /></Layout>} />
        <Route path="/player-stats" element={<Layout><PlayerStats /></Layout>} />
        <Route path="/player/:playerName" element={<Layout><PlayerProfile /></Layout>} />
        <Route path="/shop" element={<Layout><Shop /></Layout>} />
        <Route path="/login" element={<Layout><Login /></Layout>} />
        <Route
          path="/admin"
          element={
            <Layout>
              <RequireAdmin>
                <Admin />
              </RequireAdmin>
            </Layout>
          }
        />
        <Route
          path="/admin/add-fixture"
          element={
            <Layout>
              <RequireAdmin>
                <AddFixture />
              </RequireAdmin>
            </Layout>
          }
        />
        <Route
          path="/admin/game-sheet"
          element={
            <Layout>
              <RequireAdmin>
                <GameSheet />
              </RequireAdmin>
            </Layout>
          }
        />
        <Route
          path="/admin/add-player"
          element={
            <Layout>
              <RequireAdmin>
                <AddPlayer />
              </RequireAdmin>
            </Layout>
          }
        />
        <Route
          path="/admin/amend-player"
          element={
            <Layout>
              <RequireAdmin>
                <AmendPlayer />
              </RequireAdmin>
            </Layout>
          }
        />
        <Route
          path="/admin/delete-player"
          element={
            <Layout>
              <RequireAdmin>
                <DeletePlayer />
              </RequireAdmin>
            </Layout>
          }
        />
        <Route
          path="/admin/add-team-logo"
          element={
            <Layout>
              <RequireAdmin>
                <AddTeamLogo />
              </RequireAdmin>
            </Layout>
          }
        />
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  );
};

export default App;
